import React from 'react';
import DescriptionIcon from '@mui/icons-material/Description';
import { MODULE_ICONS } from './modulesConfig';

/**
 * Card de módulo — layout dark hub.
 * Contratos (featured) abre o mapa; demais navegam para path.
 */
export default function ModuleCard({ module, skeleton, featured, stats, onOpenMap, onNavigate }) {
  if (skeleton) {
    return (
      <div
        className={`module-card${featured ? ' module-card--featured' : ''} module-card--skeleton`}
        aria-hidden="true"
      >
        <div className="module-card__body">
          <div className="module-card__icon module-card__icon--skeleton" />
          <div className="module-card__name module-card__name--skeleton" />
        </div>
      </div>
    );
  }

  const IconComponent = MODULE_ICONS[module.icon] || MODULE_ICONS.Description;
  const isContratos = module.id === 'contratos';
  const isFeatured = featured || isContratos;

  const activate = () => {
    if (isContratos) {
      onOpenMap?.();
      return;
    }
    onNavigate?.(module.path);
  };

  return (
    <div
      role="button"
      tabIndex={0}
      className={`module-card${isFeatured ? ' module-card--featured' : ''}`}
      onClick={activate}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          activate();
        }
      }}
      aria-label={isContratos ? 'Abrir mapa de fiscais — Contratos' : `Acessar ${module.name}`}
    >
      <div className="module-card__body">
        <div className="module-card__icon">
          <IconComponent sx={{ fontSize: isFeatured ? 36 : 32 }} />
        </div>
        <p className="module-card__name">{module.name}</p>
        {isFeatured && (
          <>
            <p className="module-card__desc">
              {stats?.fiscais != null
                ? `${stats.fiscais} fiscal${stats.fiscais === 1 ? '' : 'is'} ativo${stats.fiscais === 1 ? '' : 's'} e ${stats.contratos ?? '—'} contrato${(stats.contratos || 0) === 1 ? '' : 's'} acompanhados. Clique para abrir o mapa de fiscais.`
                : 'Abra o mapa de fiscais. No núcleo Contratos você entra no módulo consolidado.'}
            </p>
            <button
              type="button"
              className="module-card__cta"
              onClick={(e) => {
                e.stopPropagation();
                onOpenMap?.();
              }}
            >
              Abrir mapa de fiscais
            </button>
          </>
        )}
      </div>
      {isFeatured && (
        <div className="module-card__radar" aria-hidden="true">
          <div className="module-card__radar-ring" style={{ width: '90%', height: '90%' }} />
          <div className="module-card__radar-ring" style={{ width: '65%', height: '65%' }} />
          <div className="module-card__radar-ring" style={{ width: '40%', height: '40%' }} />
          <div className="module-card__radar-core">
            <DescriptionIcon sx={{ fontSize: 22 }} />
          </div>
          <span className="module-card__radar-dot" style={{ left: '78%', top: '28%' }} />
          <span className="module-card__radar-dot" style={{ left: '22%', top: '55%' }} />
          <span className="module-card__radar-dot" style={{ left: '70%', top: '72%' }} />
        </div>
      )}
    </div>
  );
}
